import { IconProps } from '@components/Icons/Menu/index';

const defaultSize = 24;

export const StockManagementIcon = ({ size, className }: IconProps) => {
  const sizeToUse = size || defaultSize;
  return (
    <svg
      className={className}
      width={sizeToUse}
      height={sizeToUse}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 22.45V2.5L4.5 4L6 2.5L7.5 4L9 2.5L10.5 4L12 2.5L13.5 4L15 2.5L16.5 4L18 2.5L19.5 4L21 2.5V22.45L19.5 20.95L18 22.45L16.5 20.95L15 22.45L13.5 20.95L12 22.45L10.5 20.95L9 22.45L7.5 20.95L6 22.45L4.5 20.95L3 22.45ZM4.5 19.925H19.5V5.025H4.5V19.925Z"
        fill="white"
      />
      <rect x="7" y="7.5" width="10" height="10" stroke="white" strokeWidth="2" />
    </svg>
  );
};
